export function copy() {
    document.querySelectorAll('[data-copy]').forEach((div) => {
        const input = div.querySelector('input');
        const button = div.querySelector('button');

        button.addEventListener('click', (event) => {
            button.classList.add('active');

            navigator.clipboard.writeText(input.value);

            setTimeout(() => {
                button.classList.remove('active');
            }, 2000);
        });
    });
}
